import { render, staticRenderFns } from "./PurchasesInvoiceSelector.vue?vue&type=template&id=5b42efe4"
import script from "./PurchasesInvoiceSelector.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports